import {CHANGE_LANGUAGE} from '../changeLanguage';

export function changeLanguage(languageId) {
    return {
        type: CHANGE_LANGUAGE,
        languageId
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/changeLanguage.js